export const normalizeInsuranceErrors = ({
	company_prb,
	company,
	messages,
}) => {
	const lowerMsg = messages.toLowerCase()

	const rulesCompanyPrb = {
		คุ้มภัยโตเกียวมารีนประกันภัย: [
			{
				keywords: [
					'error',
					'soap',
					'contactadmin',
					'credit',
					'timeout',
					'server',
					'SendReqPolicyResult',
					'WSDL',
					'Cannot',
					'socket disconnected',
					'certificate has expired',
					'Connect Database',
					'connect ETIMEDOUT',
					'read ECONNRESET',
					'tmwsapep',
					'Record is Locked',
				],
				message: 'พบปัญหาจากบริษัทประกัน รบกวนติดต่อเจ้าหน้าที่',
			},
			{
				keywords: ['duplication', 'พบเลขตัวถังในระบบที่กรมธรรม์'],
				message:
					'กรุณาตรวจสอบวันหมดความคุ้มครองในระบบ ให้แจ้งงานโดยใช้วันที่ที่ไม่ซ้ำกับวันสิ้นสุดความคุ้มครองเดิม',
			},
			{
				keywords: ['ทะเบียนรถ'],
				message: 'กรุณาตรวจสอบเลขทะเบียนแจ้งแก้ไขตาม format เช่น 1กก2541',
			},
			{
				keywords: ['บัตรประชาชน', 'หมายเลขยืนยันผู้เอาประกันภัย'],
				message: 'กรุณาตรวจสอบเลขบัตรผู้เอาประกันภัย',
			},
			{
				keywords: ['รหัสลูกค้าเต็ม'],
				message: 'กรุณาแจ้งทางผู้พัฒนา หรือแจ้งบริษัทประกันตรวจสอบ',
			},
			{
				keywords: ['น้อยกว่าวันนี้ปัจจุบัน', 'ล่วงหน้าเกิน'],
				message: 'กรุณาตรวจสอบวันที่คุ้มครอง',
			},
			{
				keywords: ['ติดต่อฝ่ายรับประกัน'],
				message: 'ระบบไม่รองรับรุ่นรถนี้',
			},
			{
				keywords: ['suspect'],
				message: 'บริษัทประกันภัยไม่รองรับบุคคลดังกล่าว',
			},
		],
		'อินทรประกันภัย(สาขาสีลม)': [
			{
				keywords: ['กรมธรรม์ซ้ำ'],
				message:
					'กรุณาตรวจสอบวันที่เริ่มคุ้มครอง ให้ไม่ซ้ำวันที่สิ้นสุดคุ้มครองเดิม',
			},
			{
				keywords: ['capacity'],
				message: 'เครื่องยนต์ (CC) ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
			},
			{
				keywords: ['idNo is invalid'],
				message: 'กรุณาตรวจสอบเลขผู้เสียภาษีอีกครั้ง',
			},
			{
				keywords: ['Transaction timed', 'Error'],
				message: 'พบปัญหาจากบริษัทประกัน รบกวนติดต่อเจ้าหน้าที่',
			},
		],
		ทิพยประกันภัย: [
			{
				keywords: ['field Vat', 'ValidateBlackList'],
				message: 'กรุณาเปลี่ยนบริษัทประกันภัยอื่นแทน',
			},
			{
				keywords: ['EffectiveDate < AppSignDate'],
				message: 'ไม่สามารถคุ้มครองย้อนหลังได้ กรุณาตรวจสอบวันคุ้มครอง',
			},
			{
				keywords: ['DuplicatedPolicyNo'],
				message: 'รถยนต์ดังกล่าวมีความคุ้มครองอยู่แล้ว',
			},
			{
				keywords: ['DuplicatedPolicyNo'],
				message: 'รถยนต์ดังกล่าวมีความคุ้มครองอยู่แล้ว',
			},
			{
				keywords: ['CC is missing'],
				message: 'เครื่องยนต์ (CC) ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
			},
			{
				keywords: ['VehicleWeight is missing'],
				message: 'น้ำหนักรถไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
			},
			{
				keywords: ['field Seat'],
				message: 'ที่นั่งรถไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
			},
		],
		บริษัทกลาง: [
			{
				keywords: ['SQLSTATE'],
				message: 'กรุณาเปลี่ยนบริษัทประกันภัยอื่นแทน',
			},
			{
				keywords: ['กรมธรรม์ซ้ำ'],
				message: 'กรมธรรม์ซ้ำทางบริษัทประกัน',
			},
			{
				keywords: ['The address must not be greater than 10 characters'],
				message: 'ที่อยู่ให้ไม่เกิน 10 ตัวอักษร',
			},
			{
				keywords: [
					'Authorization Token not found',
					'Invalid User',
					'พบข้อผิดพลาด',
					'Too Many Attempts',
				],
				message: 'แจ้งผู้พัฒนา เพื่อตรวจสอบและติดต่อกับบริษัทประกัน',
			},
		],
		ฟอลคอนประกันภัย: [
			{
				keywords: ['SQLSTATE'],
				message: 'กรุณาเปลี่ยนบริษัทประกันภัยอื่นแทน',
			},
			{
				keywords: [
					'Authorization Token not found',
					'Invalid User',
					'พบข้อผิดพลาด',
					'Too Many Attempts',
				],
				message: 'แจ้งผู้พัฒนา เพื่อตรวจสอบและติดต่อกับบริษัทประกัน',
			},
			{
				keywords: ['The address must not be greater than 10 characters'],
				message: 'ที่อยู่ให้ไม่เกิน 10 ตัวอักษร',
			},
		],
		เออร์โกประกันภัย: [
			{
				keywords: ['SQLSTATE'],
				message: 'กรุณาเปลี่ยนบริษัทประกันภัยอื่นแทน',
			},
			{
				keywords: [
					'Authorization Token not found',
					'Invalid User',
					'พบข้อผิดพลาด',
					'Too Many Attempts',
				],
				message: 'แจ้งผู้พัฒนา เพื่อตรวจสอบและติดต่อกับบริษัทประกัน',
			},
		],
		แอกซ่าประกันภัย: [
			{
				keywords: ['SQLSTATE'],
				message: 'กรุณาเปลี่ยนบริษัทประกันภัยอื่นแทน',
			},
			{
				keywords: ['Address1'],
				message: 'กรุณาตรวจสอบที่อยู่อีกครั้ง ที่อยู่เกิน 30 ตัวอักษร',
			},
			{
				keywords: ['premium not match!'],
				message: 'กรุณาเลือกชนิดรถให้ตรงกับประเภท พ.ร.บ.',
			},
			{
				keywords: [
					'Authorization Token not found',
					'Invalid User',
					'พบข้อผิดพลาด',
					'Too Many Attempts',
				],
				message: 'แจ้งผู้พัฒนา เพื่อตรวจสอบและติดต่อกับบริษัทประกัน',
			},
			{
				keywords: ['The address must not be greater than 10 characters'],
				message: 'ที่อยู่ให้ไม่เกิน 10 ตัวอักษร',
			},
		],
		วิริยะประกันภัย: [
			{
				keywords: ['houseNumber expected maxLength: 15'],
				message: 'กรุณาตรวจสอบที่อยู่อีกครั้ง ที่อยู่เกิน 15 ตัวอักษร',
			},
		],
	}

	const rulesCompany = {
		คุ้มภัยโตเกียวมารีนประกันภัย: [
			{
				keywords: [
					'error',
					'soap',
					'contactadmin',
					'credit',
					'timeout',
					'server',
					'SendReqPolicyResult',
					'WSDL',
					'Cannot',
					'socket disconnected',
					'certificate has expired',
					'Connect Database',
					'connect ETIMEDOUT',
					'read ECONNRESET',
					'tmwsapep',
					'Record is Locked',
				],
				message: 'พบปัญหาจากบริษัทประกัน รบกวนติดต่อเจ้าหน้าที่',
			},
			{
				keywords: ['duplication', 'พบเลขตัวถังในระบบที่กรมธรรม์'],
				message:
					'กรุณาตรวจสอบวันหมดความคุ้มครองในระบบ ให้แจ้งงานโดยใช้วันที่ที่ไม่ซ้ำกับวันสิ้นสุดความคุ้มครองเดิม',
			},
			{
				keywords: ['ทะเบียนรถ'],
				message: 'กรุณาตรวจสอบเลขทะเบียนแจ้งแก้ไขตาม format เช่น 1กก2541',
			},
			{
				keywords: ['บัตรประชาชน', 'หมายเลขยืนยันผู้เอาประกันภัย'],
				message: 'กรุณาตรวจสอบเลขบัตรผู้เอาประกันภัย',
			},
			{
				keywords: ['รหัสลูกค้าเต็ม'],
				message: 'กรุณาแจ้งทางผู้พัฒนา หรือแจ้งบริษัทประกันตรวจสอบ',
			},
			{
				keywords: ['น้อยกว่าวันนี้ปัจจุบัน', 'ล่วงหน้าเกิน'],
				message: 'กรุณาตรวจสอบวันที่คุ้มครอง',
			},
			{
				keywords: ['ติดต่อฝ่ายรับประกัน'],
				message: 'ระบบไม่รองรับรุ่นรถนี้',
			},
			{
				keywords: ['suspect'],
				message: 'บริษัทประกันภัยไม่รองรับบุคคลดังกล่าว',
			},
		],
		ชับบ์สามัคคีประกันภัย: [
			{
				keywords: [
					'แผนนี้รองรับการคุ้มครองเฉพาะแบบเต็มปี',
					'ไม่สามารถตรวจสอบประวัติ',
					'ไม่มีแพคเกจ',
				],
				message: 'เว็บตรอไม่รองรับ แจ้งงานผ่านเว็บหรือแอปหลัก',
			},
			{
				keywords: ['ไม่สามารถหารุ่นรถ'],
				message:
					'ระบบของ ชับบ์ไม่รองรับรุ่นรถ ปีรถนี้ แจ้งงานผ่านเว็บหรือแอปหลัก',
			},
			{
				keywords: ['get premium fail', 'policy fail'],
				message: ' ติดต่อเจ้าหน้าเพื่อตรวจสอบ',
			},
			{
				keywords: ['SumInsured '],
				message: ' ทุนประกันต้องอยู่ระหว่างแจ้งเตือน',
			},
		],
		ไทยไพบูลย์ประกันภัย: [
			{
				keywords: ['another Policy'],
				message:
					'กรุณาตรวจสอบวันหมดความคุ้มครองในระบบ ให้แจ้งงานโดยใช้วันที่ที่ไม่ซ้ำกับวันสิ้นสุดความคุ้มครองเดิม',
			},
		],
		อินทรประกันภัย: [
			{
				keywords: ['CusTelNumber'],
				message: 'กรุณาตรวจสอบเบอร์โทรศัพท์อีกครั้ง',
			},
		],
	}

	const matchRule = (rules) => {
		for (const { keywords, message } of rules) {
			if (keywords.some((k) => lowerMsg.includes(k.toLowerCase()))) {
				return message
			}
		}
		return null
	}

	const prbRules = rulesCompanyPrb[company_prb]
	if (prbRules) {
		const msg = matchRule(prbRules)
		if (msg) return msg
	}

	const compRules = rulesCompany[company]
	if (compRules) {
		const msg = matchRule(compRules)
		if (msg) return msg
	}

	return messages
}
